import Core from '@core_modules/checkout/plugins/AddressForm/core';
import Content from '@core_modules/checkout/plugins/AddressForm/components';

const DefaultAddressForm = (props) => (
    <Core {...props} Content={Content} />
);

export default DefaultAddressForm;
